import { createTRPCClient, httpBatchLink, TRPCClientError } from "@trpc/client";
export { TRPCClientError };
/**
 * One client factory shared by Next.js and React Native — each app only
 * supplies `apiUrl` and how to read its own stored access token (cookie vs.
 * SecureStore), so the request/typing contract never drifts between them.
 */
export function createWelopeClient({ apiUrl, getAccessToken, useCookies = false, extraHeaders, }) {
    return createTRPCClient({
        links: [
            httpBatchLink({
                url: `${apiUrl}/trpc`,
                async headers() {
                    const token = await getAccessToken();
                    return {
                        ...(token ? { authorization: `Bearer ${token}` } : {}),
                        ...(await extraHeaders?.()),
                    };
                },
                fetch: useCookies
                    ? (input, init) => fetch(input, { ...init, credentials: "include" })
                    : undefined,
            }),
        ],
    });
}
